import { render } from "./EditTutarial.vue?vue&type=template&id=425febaf&scoped=true"
import script from "./EditTutarial.vue?vue&type=script&lang=js"
export * from "./EditTutarial.vue?vue&type=script&lang=js"

import "./EditTutarial.vue?vue&type=style&index=0&id=425febaf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-425febaf"]])

export default __exports__